import React, { useContext, useState } from 'react';
import { toCurrency } from '../../../../utilities/FormatHelpers';
import { AccountContext } from '../../AccountContext';
import { useConsumerBillingService } from '@app/sdk';
import { useAsyncEffect } from '@app/hooks';

export default function DueAllocations(props: { transactionId: string }) {
  const { accountId } = useContext(AccountContext);
  const { transactionId } = props;
  const [dueAllocations, setDueAllocations] = useState({} as any);
  const consumerBillingService = useConsumerBillingService();

  useAsyncEffect(async () => {
    let dueAllocationsResponse = await consumerBillingService.getDuesAllocation(accountId, transactionId);

    if (!dueAllocationsResponse) return;
    setDueAllocations({ loaded: true, ...dueAllocationsResponse });
  }, [transactionId]);

  return dueAllocations.loaded ? (
    <div className="ui list">
      {dueAllocations.allocations?.map((allocation) => (
        <div className="item" key={allocation.billingPeriodId}>
          <div className="ui label">
            BP {allocation.billingPeriodId}
            <div className="detail">{toCurrency(allocation.allocatedAmount.value)}</div>
          </div>
        </div>
      ))}
    </div>
  ) : null;
}
